// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__VZzta","rootCenter":"LoadMoreObserver_rootCenter__2ryes","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__3DtZZ"};